import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Cell, flexRender } from "@tanstack/react-table";
import { CSSProperties, useMemo } from "react";

interface TestTdProps<T, TValue> {
  cell: Cell<T, TValue>;
}
export const TestTd = <T, TValue>({ cell }: TestTdProps<T, TValue>) => {
  const { isDragging, setNodeRef, transform } = useSortable({
    id: cell.column.id,
  });

  const isPinned = cell.column.getIsPinned();
  const isLastLeftPinnedColumn = isPinned === "left" && cell.column.getIsLastColumn("left");
  const isFirstRightPinnedColumn = isPinned === "right" && cell.column.getIsFirstColumn("right");

  const style: CSSProperties = useMemo(
    () => ({
      boxShadow: isLastLeftPinnedColumn
        ? "-4px 0 4px -4px gray inset"
        : isFirstRightPinnedColumn
          ? "4px 0 4px -4px gray inset"
          : undefined,
      left: isPinned === "left" ? `${cell.column.getStart("left")}px` : undefined,
      right: isPinned === "right" ? `${cell.column.getAfter("right")}px` : undefined,
      opacity: isDragging || isPinned ? 0.9 : 1,
      position: isPinned ? "sticky" : "relative",
      transform: CSS.Translate.toString(transform),
      width: `calc(var(--col-${cell.column.id}-size) * 1px)`,
      zIndex: isDragging || isPinned ? 1 : 0,
      overflow: "hidden",
    }),
    [isPinned, isDragging, transform, cell.column, isLastLeftPinnedColumn, isFirstRightPinnedColumn]
  );
  return (
    <div
      style={style}
      ref={setNodeRef}
      className={`h-full flex items-center justify-center px-2 text-center min-w-0 w-full text-xs 2xl:text-sm 2xl:h-12 ${isPinned && "bg-background"} `}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </div>
  );
};
